// Copyright (C) 2016 Sergey Akopkokhyants
// This project is licensed under the terms of the MIT license.
// https://github.com/akserg/ng2-slim-loading-bar
import * as ɵngcc0 from '@angular/core';
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { NgModule } from "@angular/core";
import { SlimLoadingBarComponent } from './src/slim-loading-bar.component';
import { SlimLoadingBarService } from './src/slim-loading-bar.service';
export * from './src/slim-loading-bar.component';
export * from './src/slim-loading-bar.service';
var SlimLoadingBarModule = /** @class */ (function () {
    function SlimLoadingBarModule() {
    }
    SlimLoadingBarModule_1 = SlimLoadingBarModule;
    SlimLoadingBarModule.forRoot = function () {
        return {
            ngModule: SlimLoadingBarModule_1,
            providers: [SlimLoadingBarService]
        };
    };
    var SlimLoadingBarModule_1;
SlimLoadingBarModule.ɵfac = function SlimLoadingBarModule_Factory(t) { return new (t || SlimLoadingBarModule)(); };
SlimLoadingBarModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SlimLoadingBarModule });
SlimLoadingBarModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [SlimLoadingBarService] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SlimLoadingBarModule, [{
        type: NgModule,
        args: [{
                declarations: [SlimLoadingBarComponent],
                exports: [SlimLoadingBarComponent],
                providers: [SlimLoadingBarService]
            }]
    }], function () { return []; }, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SlimLoadingBarModule, { declarations: function () { return [SlimLoadingBarComponent]; }, exports: function () { return [SlimLoadingBarComponent]; } }); })();
    return SlimLoadingBarModule;
}());
export { SlimLoadingBarModule };

